import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { setScanLibConfig } from "mray_scan_lib";

import { router } from "./router";

import reportWebVitals from "./reportWebVitals.ts";
import AppProviders from "./components/AppProviders.tsx";
// Import Roboto font styles
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

// Global providers are consolidated in AppProviders

// Configure the shared mray_scan_lib once before the app renders. The importer
// exposes the scan API as scanApiUrl and the DICOMweb gateway as dicomWebApiUrl.
setScanLibConfig({
  apiBaseUrl: window.ENV.scanApiUrl,
  dicomWebUrl: window.ENV.dicomWebApiUrl,
});

// Render the app
const rootElement = document.getElementById("app");

if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <AppProviders>
        <RouterProvider router={router} />
      </AppProviders>
    </StrictMode>,
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
